export default {
  orders: [],
  transporter: [],
  products: [],
  status: [],
  error: false,
  errorMessage: '',
  states: [],
  states_auth: [],
  params: {
    filter_date: [],
    filter_status: [],
    filter_status_auth:[],
    paginate: true,
    sortBy: 'id',
    sort: 'DESC',
    warehouse: 0
  },
}



// WEBPACK FOOTER //
// ./src/b2b/modules/orders-history/state.js